import { Directive, ElementRef, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { themes } from './themes.const';
import { ThemeService } from './theme.service';
import { Subscription } from 'rxjs';
import { Constants } from '../app.constants';
import { OrgService } from '../organization/org.service';
import { UserService } from '../user/user.service';
import { ActivatedRoute } from '@angular/router';

@Directive({
  selector: '[appTheme]'
})
export class ThemeDirective implements OnInit, OnDestroy {

  private themeName = Constants.Default;
  private themServiceSubscription: Subscription;
  constructor(private elementRef: ElementRef,
    @Inject(DOCUMENT) private document: any,
    private themService: ThemeService
    , private orgService: OrgService
    , private userService: UserService
    , private route: ActivatedRoute) { }

  ngOnInit() {
    if (this.userService.getAuthToken()) {
      this.orgService.getOrganizationTheme().subscribe((theme: any) => {
        if (theme != null && theme != '') {
          if (theme.name != null && theme.name != '') {
            if (theme.name == Constants.StrongRedFromDB) {
              this.themeName = Constants.StrongRed;
            } else if (theme.name == Constants.DarkRedFromDB) {
              this.themeName = Constants.DarkRed;
            } else if (theme.name == Constants.OhioUniversityFromDB) {
              this.themeName = Constants.OhioUniversity;
            } else if (theme.name == Constants.ClaymontSchoolsFromDB) {
              this.themeName = Constants.ClaymontSchools;
            } else if (theme.name == Constants.WrightStateUFromDB) {
              this.themeName = Constants.WrightState;
            } else if (theme.name == Constants.DarkGreyFromDB) {
              this.themeName = Constants.DarkGrey;
            }else if (theme.name == Constants.NorthAlleghenyFromDB) {
              this.themeName = Constants.NorthAllegheny;
            }
             else {
              this.themeName = theme.name;
            }
          }
        }
        this.updateTheme(this.themeName);
        this.themService.getActiveTheme()
          .subscribe(themeName => {
            this.themeName = themeName;
            this.updateTheme(themeName);
          });
      });
    } else {
      this.updateTheme(this.themeName);
      this.themService.getActiveTheme()
        .subscribe(themeName => {
          this.themeName = themeName;
          this.updateTheme(themeName);
        });
    }
  }

  updateTheme(themeName) {
    const element = this.elementRef.nativeElement;
    const them = themes[themeName];
    for (const key in them) {
      if (them.hasOwnProperty(key)) {
        element.style.setProperty(key, them[key]);
        this.document.body.style.setProperty(key, them[key]);
      }
    }
  }

  ngOnDestroy() {
    if (this.themServiceSubscription) {
      this.themServiceSubscription.unsubscribe();
    }
  }

}
